import { Component, Input } from '@angular/core';
import { TurnoAsignado } from '../../models/Turno.model';

@Component({
  selector: 'app-lista-asignados',
  imports: [],
  templateUrl: './lista-asignados.html',
  styleUrl: './lista-asignados.scss'
})
export class ListaAsignados {
  @Input() turnosAsignados: TurnoAsignado[] = [];

  get turno1(): TurnoAsignado {
    if (this.turnosAsignados.length === 0) {
      return {
        id: '',
        tramite: '',
        claveTurno: '',
        puesto: ''
      };
    }

    const turno = this.turnosAsignados[0];
    return turno;
  }

  get turno2(): TurnoAsignado {
    if (this.turnosAsignados.length < 2) {
      return {
        id: '',
        tramite: '',
        claveTurno: '',
        puesto: ''
      };
    }

    const turno = this.turnosAsignados[1];
    return turno;
  }

  get turno3(): TurnoAsignado {
    if (this.turnosAsignados.length < 3) {
      return {
        id: '',
        tramite: '',
        claveTurno: '',
        puesto: ''
      };
    }

    const turno = this.turnosAsignados[2];
    return turno;
  }

  get turno4(): TurnoAsignado {
    if (this.turnosAsignados.length < 4) {
      return {
        id: '',
        tramite: '',
        claveTurno: '',
        puesto: ''
      };
    }

    const turno = this.turnosAsignados[3];
    return turno;
  }

}
